$(() => {
  const physicians_on_staff = () => {
    const number_of_employees = parseInt($('#number-of-employees').val().replace(',', ''), 10);

    return Math.round(number_of_employees / 25);
  };

  const run = () => {
    if ($('#physicians-on-staff-overridden').val() === '0') {
      $('#physicians-on-staff').val(physicians_on_staff());
      $('#physicians-on-staff').change();
    }
  };

  run();

  $('#number-of-employees').blur(() => {
    run();
  });

  $('#physicians-on-staff').blur(() => {
    $('#physicians-on-staff-overridden').val('1');
  });
});
